import { ContentSection } from "../layout/ContentSection"
import { BreakableText, Skill } from "../ui/CustomTypography"
import { Typography } from "@mui/material"
import React, { type ReactNode } from "react"

export const Skills = () => {
    const renderSkills = (skills: (string | ReactNode)[]) => {
        return skills.map((skill, index) => (
            <React.Fragment key={index}>
                {typeof skill === "string" ? <Skill>{skill}</Skill> : skill}
                {index < skills.length - 1 && ", "}
            </React.Fragment>
        ))
    }

    const programmingSkills = ["Python", "SQL", "Go", "Rust", "TypeScript", "JavaScript", "Bash"]

    const cloudSkills = [
        "GCP",
        "Apache Beam/Dataflow",
        "Apache Airflow/Cloud Composer",
        "BigQuery",
        "Pub/Sub",
        "Cloud Storage",
        "Cloud Run",
        "Cloud SQL",
        "Firestore",
        "Cloud Tasks",
        "AWS",
        "Elasticsearch",
        "Databases (SQL & NoSQL)",
        "MongoDB",
        "Real-Time & Streaming Data Processing",
        "Batch Data Pipelines",
        "Asynchronous Processing",
        "Distributed Systems",
        "ETL/ELT Workflows",
    ]

    const infraSkills = [
        "Python Package Development",
        "Git",
        "Docker",
        "GitHub Actions",
        "Terraform",
        "Terragrunt",
        "Linux",
        "IAM",
        <>
            <Skill>
                continuous <BreakableText>integration/deployment</BreakableText>
            </Skill>{" "}
            (<Skill>CI/CD</Skill>)
        </>,
        <>
            <Skill>Infrastructure as Code</Skill> (<Skill>IaC</Skill>)
        </>,
        "Trivy",
        "SonarCloud",
    ]

    const aiMlSkills = [
        "LangChain",
        "Artificial Intelligence",
        "Machine Learning",
        "Supervised and unsupervised learning",
        "Tree-based models",
        "Time Series",
        "NLP",
        "Neural Network",
        "Deep Learning",
        "Optimization",
        <Skill key="liner-programming">
            <BreakableText>(Integer/Mixed)</BreakableText> Linear Programming
        </Skill>,
        "TensorFlow",
        "Scikit-Learn",
        "XGBoost",
        "Optuna",
        "Pandas",
        "NumPy",
    ]

    const softwareDevSkills = [
        "Design patterns",
        "Functional Programming",
        "OOP",
        "React",
        "Node.js",
        "Streamlit",
        "FastAPI",
        "Test Driven Development (TDD)",
        "System Design",
    ]

    const otherExpertiseSkills = [
        "Finance",
        "Credit Card",
        "Risk Model",
        "Statistics",
        "Financial Analysis",
        "Oil & Gas Production",
    ]

    return (
        <ContentSection title="Skills">
            <Typography variant="body1">
                • Programming Languages & Tools: {renderSkills(programmingSkills)}
            </Typography>
            <Typography variant="body1">
                • Cloud & Data Engineering: {renderSkills(cloudSkills)}
            </Typography>
            <Typography variant="body1">
                • Infrastructure & DevOps: {renderSkills(infraSkills)}
            </Typography>
            <Typography variant="body1">• AI/ML & Data Science: {renderSkills(aiMlSkills)}</Typography>
            <Typography variant="body1">
                • Software Development: {renderSkills(softwareDevSkills)}
            </Typography>
            <Typography variant="body1">
                • Domain Expertise: {renderSkills(otherExpertiseSkills)}
            </Typography>
            <Typography variant="body1">
                • <Skill>Thai</Skill> (Native), <Skill>English</Skill> (Upper Intermediate, 7 years
                working in English-speaking teams), <Skill>Hiring</Skill>, <Skill>Mentoring</Skill>,{" "}
                <Skill>Project Management</Skill>
            </Typography>
        </ContentSection>
    )
}
